export enum StatusType {
  success = "success",
  failed = "failed",
}

export interface StatusContent {
  title: string;
  description?: string;
  additional?: string;
}

export interface StatusConfig {
  [StatusType.success]: StatusContent;
  [StatusType.failed]: StatusContent;
}
